import { EMPTY } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Line } from '../models/line.model';
import { Ont } from '../models/ont.model';
import { ModemChoiceService } from '../modem-choice.service';

@UntilDestroy()
@Component({
  selector: 'mprd-modem-choice-onts',
  templateUrl: './modem-choice-onts.component.html',
})
export class ModemChoiceOntsComponent {
  @Input() line!: Line;
  @Output() addModalOpened = new EventEmitter<void>();
  @Output() editModalOpened = new EventEmitter<{ ncName: string }>();
  @Output() deleteModalOpened = new EventEmitter<{ ncName: string }>();
  @Output() activated = new EventEmitter<Ont>();
  pending = false;

  constructor(private modemChoiceService: ModemChoiceService) {}

  onOpenAddModal(): void {
    this.addModalOpened.emit();
  }

  onOpenEditModal(ncName: string): void {
    this.editModalOpened.emit({ ncName });
  }

  onOpenDeleteModal(ncName: string): void {
    this.deleteModalOpened.emit({ ncName });
  }

  onActivated(ncName: string, active: boolean): void {
    this.pending = true;
    const clickedOnt = this.line.devices.find(
      (device) => device.ncName === ncName,
    );
    const activatedOnt = active
      ? clickedOnt
      : this.line.devices.find((device) => !device.active);
    const deactivatedOnt = active
      ? this.line.devices.find((device) => device.active)
      : clickedOnt;
    this.modemChoiceService
      .updateOnt(this.line.circuitId, activatedOnt.ncName, {
        active: true,
        utac: this.line.utac,
      })
      .pipe(
        tap(() => {
          this.activated.emit({ ...activatedOnt, active: true });
          this.activated.emit({ ...deactivatedOnt, active: false });
        }),
        catchError(() => {
          this.activated.emit({ ...clickedOnt, active: !active });
          throw EMPTY;
        }),
        finalize(() => (this.pending = false)),
        untilDestroyed(this),
      )
      .subscribe();
  }
}
